import { call, delay, put, select, takeEvery } from 'redux-saga/effects';

import { actions as uiActions, selectors as uiSelectors } from '@elab/core/store/ui';
import { get as sessionGetItem, remove as sessionRemoveItem } from '@elab/core/utils/session';
import { SHOULD_SCROLL_KEY } from '@elab/core/utils/constants';

import { addForm, addReviewList, loadLibrary } from './helpers';

import { actions, selectors, types } from '.';

function* powerReviewsLoadLibrary() {
    const isInitialized = yield select(selectors.isInitialized);
    const settings = yield select(selectors.getSettings);
    if (!isInitialized) {
        loadLibrary(settings);
        yield put(actions.setInitialized(true));
    }
    return settings;
}

function* powerReviewsInstallReviewList() {
    const settings = yield call(powerReviewsLoadLibrary);
    const windowSize = yield select(uiSelectors.getWindowSize);
    addReviewList(settings, windowSize);
    const pdpReviewHash = sessionGetItem(SHOULD_SCROLL_KEY);
    if (pdpReviewHash) {
        yield call(sessionRemoveItem, SHOULD_SCROLL_KEY);
        yield delay(400);
        yield put(uiActions.scrollToTop({ target: pdpReviewHash, shift: 70 }));
    }
}

function* powerReviewsInstallForm() {
    const settings = yield call(powerReviewsLoadLibrary);
    addForm(settings);
}

function* watchInstallReviewList() {
    yield takeEvery(types.INSTALL_REVIEWLIST, powerReviewsInstallReviewList);
}

function* watchInstallForm() {
    yield takeEvery(types.INSTALL_FORM, powerReviewsInstallForm);
}

export default [watchInstallReviewList(), watchInstallForm()];
